// extracted by css-extract-rspack-plugin
export default {"checkbox":"QVn9VMYV","disabled":"B9nulg6C","input":"lnElPh7b","box":"WKlRsydu","checked":"_yh6_0kG","checkmark":"a_wq4ns7"};